export const eventTargetPlatforms = {
  MICROSOFT_TEAMS: 'MicrosoftTeams',
  TELEGRAM: 'Telegram',
};
